export default __webpack_public_path__ + "static/media/010-london eye.3a62be6f.svg";